export const downloadFile = (data: string, filename: string) => {
  if (data) {
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = data;
    tempLink.setAttribute('download', filename);
    tempLink.setAttribute('target', '_blank');
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
};
